import React from 'react';
import { connect } from 'react-redux';

import { State } from '../../../lib/reducers';

import { isMobileOnly, isMobileSafari } from 'react-device-detect';
import IconButton from '@material-ui/core/IconButton';
import { IconMore } from '../../IconSet';
import StyledMenu from '../../StyledMenu';
import Home from './Home';
import MediaSettings from './MediaSettings';
import MobileFullScreen from './MobileFullScreen';
import RoomInfo from './RoomInfo';
import ActionRoomMenu from '../../SiteTitle/ActionRoomMenu';


type MappedProps = {
  inMeeting: boolean;
};

const mapStateToProps = (state: State): MappedProps => ({
  inMeeting: Boolean(state.websocket.room),
});


function Actions(props: MappedProps) {
  const inMeeting = props.inMeeting;
  const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);
  const open = Boolean(anchorEl);
  const handleMenu = (event: React.MouseEvent<HTMLElement>): void => {
    setAnchorEl(event.currentTarget);
  };

  const closeMenu = (): void => setAnchorEl(null);

  const getActions = () => {
    return (
      <React.Fragment>
        <Home />
        <MediaSettings />
        { inMeeting && <RoomInfo /> }
      </React.Fragment>
    );
  };

  const getActionsMobile = () => {
    return (
      <React.Fragment>
        <IconButton size='small' onClick={handleMenu}>
          <IconMore size={24} />
        </IconButton>
        <StyledMenu
          anchorEl={anchorEl}
          getContentAnchorEl={null}
          anchorOrigin={{
            vertical: 'bottom',
            horizontal: 'right',
          }}
          keepMounted
          transformOrigin={{
            vertical: 'top',
            horizontal: 'right',
          }}
          open={open}
          onClose={closeMenu}
          onClick={closeMenu}
        >
          {getActions()}
          { !isMobileSafari && <MobileFullScreen /> }
          <ActionRoomMenu />
        </StyledMenu>
      </React.Fragment>
    );
  };

  return (
    <React.Fragment>
      { isMobileOnly ? getActionsMobile() : getActions() }
    </React.Fragment>
  );
}


export default connect(mapStateToProps)(Actions);